import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['link', 'blockquote'],
    ['clean'],
  ],
};

const formats = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'list',
  'align',
  'link', 'blockquote',
];

/**
 * Simple WYSIWYG wrapper around react-quill-new.
 * Returns HTML string via onChange.
 */
export const RichTextEditor = ({ value, onChange, placeholder = '', minHeight = 140 }) => {
  return (
    <div className="rich-text-editor" data-testid="rich-text-editor">
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{ background: 'white' }}
      />
      <style>{`
        .rich-text-editor .ql-editor { min-height: ${minHeight}px; }
        .rich-text-editor .ql-toolbar { border-top-left-radius: 6px; border-top-right-radius: 6px; }
        .rich-text-editor .ql-container { border-bottom-left-radius: 6px; border-bottom-right-radius: 6px; }
      `}</style>
    </div>
  );
};

export default RichTextEditor;
